const A = "/brand";

const g = (dir) =>
  `linear-gradient(${dir}, rgba(250,250,248,0) 0%, rgba(250,250,248,0.55) 58%, #FAFAF8 100%)`;

export function WorkTogether() {
  return (
    <section data-testid="work-together-section" className="relative overflow-hidden bg-[#FAFAF8]">
      {/* Full-bleed band: photo on the right dissolving into the page; text on the clean left */}
      <div className="relative w-full overflow-hidden pb-10 lg:pb-0">
        {/* Desktop image half-band */}
        <div className="hidden lg:block absolute inset-y-0 right-0 w-[56%]">
          <img
            src={`${A}/blueprint4joy-fireplace-group-conversation.jpg`}
            alt="Women sitting in an intimate circle around a fireplace, engaged in meaningful group conversation."
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover"
            style={{ objectPosition: "55% 28%" }}
          />
          <div className="absolute inset-y-0 left-0 z-[1]" style={{ width: "46%", background: g("to left") }} />
          <div className="absolute inset-x-0 top-0 h-16 z-[1]" style={{ background: g("to top") }} />
          <div className="absolute inset-x-0 bottom-0 h-16 z-[1]" style={{ background: g("to bottom") }} />
        </div>

        {/* Mobile image stacked on top */}
        <div className="lg:hidden relative w-full aspect-[4/3] mb-8">
          <img
            src={`${A}/blueprint4joy-fireplace-group-conversation.jpg`}
            alt="Women sitting in an intimate circle around a fireplace, engaged in meaningful group conversation."
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover"
            style={{ objectPosition: "50% 22%" }}
          />
          <div className="absolute inset-x-0 bottom-0 h-20 z-[1]" style={{ background: g("to bottom") }} />
        </div>

        {/* Text — over the clean left */}
        <div className="relative z-[2] max-w-7xl mx-auto px-6 md:px-10 flex items-center lg:min-h-[min(74vh,660px)]">
          <div className="w-full lg:w-1/2">
            <div className="max-w-xl">
              <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.08] tracking-tight text-[#1C1917] mb-8">
                What It&rsquo;s Like to Work Together
              </h2>
              <p className="text-xl text-[#57534E] leading-relaxed">
                The conversations we have aren&rsquo;t about fixing you. They&rsquo;re about making enough room for your own wisdom to become impossible to ignore. We slow down, get honest about what&rsquo;s true and begin building from there. Not someone else&rsquo;s version of a meaningful life. Yours.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
